// extracted by mini-css-extract-plugin
export default {"double":"value-rule_double__JVphl","doubleInput":"value-rule_doubleInput__-DA8Y"};